///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ThumbsDownIcon = ({
  height,
  fill = "#C71E0C",
  title = messages.thumbsDown.defaultMessage,
  width,
  className
}) => (
  <svg
    aria-labelledby="thumbs-down-icon"
    height={height}
    width={width}
    fill="none"
    className={className}
  >
    <title id="thumbs-down-icon">{title}</title>
    <path
      fill={fill}
      fillRule="evenodd"
      d="M4.868 10.345c.119.316-3.145 3.23-1.241 5.592.445.552 1.956-2.645 4.102-4.091 1.183-.8 3.937-2.499 3.937-3.438V2.326C11.666 1.196 7.3 0 3.98 0 2.763 0 1 7.623 1 8.835c0 1.215 3.752 1.193 3.868 1.51Zm7.687-.085c.585 0 2.667-.355 2.667-2.776V3.175C15.222.756 13.14.49 12.555.49c-.584 0 .89.508.89 2.009v5.664c0 1.572-1.474 2.097-.89 2.097Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ThumbsDownIcon;
